import { useEffect, useRef, useState } from "react";
import { TurnstileWidget } from "./TurnstileWidget";

interface LazyTurnstileProps {
  onVerify: (token: string) => void;
  onExpire?: () => void;
  onError?: () => void;
  theme?: "light" | "dark" | "auto";
  size?: "normal" | "compact" | "invisible";
  className?: string;
}

/**
 * Mounts the Turnstile widget (which loads the Cloudflare script) only when the
 * surrounding form scrolls near the viewport, keeping the script off the
 * initial page load.
 */
export const LazyTurnstile = (props: LazyTurnstileProps) => {
  const placeholderRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (visible) return;
    const node = placeholderRef.current;
    if (!node) return;

    if (!("IntersectionObserver" in window)) {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [visible]);

  return <div ref={placeholderRef}>{visible ? <TurnstileWidget {...props} /> : null}</div>;
};

export default LazyTurnstile;
